import React from 'react';
import { InfoCircledIcon } from '@radix-ui/react-icons';

export function UnderConstruction({
    actionLabel = 'Go Home',
    actionLink = '/',
    message = "We're currently embracing beautiful imperfection. Check back soon!",
    title = 'Page Under Construction',
}) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-green-50">
            <div className="max-w-md text-center p-8 bg-white rounded-lg shadow-lg">
                <InfoCircledIcon className="mx-auto w-12 h-12 text-green-500" />
                <h1 className="mt-4 text-2xl font-bold text-gray-800">{title}</h1>
                <p className="mt-2 text-gray-600">{message}</p>
                <a
                    href={actionLink}
                    className="mt-6 inline-block px-5 py-2 bg-green-500 !text-white font-medium rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-400"
                >
                    {actionLabel}
                </a>
                <p className="mt-4 text-sm text-gray-400">🍅 Embrace the beauty of imperfection 🌿</p>
            </div>
        </div>
    );
}
